export const PopUps = {
  Help: 'Help',
  Fairness: 'Fairness',
  CheckHash: 'CheckHash',
  SlowConnection: 'SlowConnection',
  Reconnect: 'Reconnect',
  ConnectionError: 'ConnectionError',
  Result: 'Result',
  MobileNavigation: 'MobileNavigation',
  GameOpen: 'GameOpen',
};

export const LostConnectionInfoStyles = {
  text: {
    fontSize: 18,
    fontWeight: 500,
    fontFamily: 'Roboto',
  },
};
export const ReconnectInfoStyles = {
  text: {
    fontSize: 12,
    fontWeight: 500,
    fontFamily: 'Roboto',
  },
  text2: {
    fontSize: 18,
    fontWeight: 500,
    fontFamily: 'Roboto',
  },
};

export const GameOpenInfoStyles = {
  text: {
    fontSize: 18,
    fontWeight: 400,
    fontFamily: 'Lato',
  },
};
